import React, {useState, useEffect, useReducer} from 'react';
import {ResetSuspendActivateModal} from 'shared-one-ux-components';
import axios from 'axios';
import find from 'lodash/find';
import {SdfBusyIndicator} from '@synerg/react-components';

export default function ResetSuspendActivateWrapper({
	isOpen,
	member = {},
	mode = 'reset',
	onClose = () => {},
	roleDescriptions,
	fetchMembers = () => {},
	setRefreshMembers,
	partnerType = 'marketplace',
	setModeState,
	adminView = false,
	ooid = ''
}) {
	const initialState = {
		firstName: '',
		lastName: '',
		email: '',
		userId: '',
		phone: '',
		countryCode: '',
		roles: [],
		organizationOID: '',
		associateOID: '',
	};
	const reducer = (state = initialState, action) => {
		switch (action.type) {
		case 'UPDATE':
			return {...action.payload};
		default:
			return state;
		}
	};

	const [modalState, setModalState] = useState('confirm'); // confirm, success, error
	const [state, dispatch] = useReducer(reducer, initialState);
	const [isBusy, setBusy] = useState(true);

	useEffect(() => {
		if (isOpen) {
			fetchDetails(member.aoid || '', adminView ? ooid : '');
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const fetchDetails = async(aoid, ooid = '') => {
		try {
			//getting member info to populate modal
			const {status, data: {member}} = await axios.get(
					`${import.meta.env.VITE_ROOT_PATH}/api/members/${aoid}${adminView
							? '?ooid='.concat(ooid)
							: ''}`);

			if (status === 200) {
				const mappedAllRoles = member.roles.map((role) => {
					const val = find(roleDescriptions, {roleCode: role.roleCode});
					const newRoleName = val ? val.title : 'NA';
					return {
						roleID: role.roleId,
						roleId: role.roleId,
						roleCode: role.roleCode,
						roleName: newRoleName,
						roleDescription: role.roleDescription,
					};
				});
				dispatch({
					type: 'UPDATE', payload: {
						firstName: member.firstName,
						lastName: member.lastName,
						email: member.email,
						phone: member.phone,
						countryCode: (member.callingCode || '').replace(/\D/g, ''),
						userId: member.userName,
						roles: mappedAllRoles,
						organizationOID: member.organizationOID,
						associateOID: member.associateOID,
					},
				});
				setBusy(false);
			} else {
				setModalState('error');
				setBusy(false);
			}

		} catch (error) {
			setModalState('error');
			setBusy(false);
		}
	};

	const handlePasswordReset = async(setModalState, setBusy) => {
		try {
			setBusy(true);
			const {userId: userName, organizationOID: ooid} = state;
			const payload = {userName};
			const {status} = await axios.post(
					`${import.meta.env.VITE_ROOT_PATH}/api/members/reset-password?ooid=${ooid}`,
					payload);

			if (status === 200) {
				setBusy(false);
				setModalState('success');
			} else {
				setBusy(false);
				setModalState('error');
			}
		} catch (error) {
			setBusy(false);
			setModalState('error');
		}
	};

	const activateOrSuspendMember = async(
			action = 'suspend', message = 'suspended', setModalState, setBusy) => {
		try {
			setBusy(true);
			const {userId: userName, associateOID, organizationOID} = state;
			const payload = {associateOID, userName};
			const {status} = await axios.post(
					`${import.meta.env.VITE_ROOT_PATH}/api/members/${action}?ooid=${organizationOID}`,
					payload);

			if (status === 200) {
				setTimeout(() => {
					setBusy(false);
					setModalState('success');
				}, 1000);
			} else {
				setBusy(false);
				setModalState('error');
			}
		} catch (e) {
			setBusy(false);
			setModalState('error');
		}

	};

	return (<div>
		{isOpen && !isBusy &&
				<ResetSuspendActivateModal member={state} mode={mode}
				                           onClose={onClose}
				                           allRoles={state.roles}
				                           initialModalState={modalState}
				                           resetPasswordCall={handlePasswordReset}
				                           activateOrSuspendMember={activateOrSuspendMember}
				                           fetchMembers={fetchMembers}
				                           setRefreshMembers={setRefreshMembers}
				                           initialBusyState={isBusy}
				                           partnerType={partnerType}
		                               setModeState={setModeState}
				/>}

		{isOpen && isBusy &&
				<SdfBusyIndicator overlay={true} size={'lg'} fullscreen={true}/>}
	</div>);
}
